<template>
<div style="margin:5px;">
      <br>
          <Row><Col span="12" offset="10"><div class="myTitle" >链接查询</div></Col></Row>
        <br>
        <Row>
                <div class="queryForm">
                    <Form ref="queryFormRef" :model="queryForm" :label-width="80" inline>
                         <FormItem label="链接地址" prop="keyword" >
                            <Input v-model="queryForm.keyword" placeholder="多个地址之间用回车键换行分开"
                            type="textarea" :rows="4" style="width:600px;"></Input>
                        </FormItem>
                      
                        <Button type="info"  @click="queryBtn" >查询</Button>
	                   
                    </form>
                </div>
            </Row>
             <br>
      <Row >
          <Col span="20" offset="1">
            <div style="float:left">
              <Button type="success"   @click="openExport()">导出</Button>
              
            </div>
          </Col>
      </Row>
      <br>
        
      <Row>
          <Col span="24">
              <Table :loading="loading" @on-selection-change="selectRow" 
                border ref="table" stripe :columns="columns4" :data="listData">
               
              
              </Table>
          </Col>
      </Row>
      <Row>
        <Col span="24">
          <div>
            <Footer>
              <Page show-sizer show-total :total="rowCount" :current="current"
                :page-size="pageSize"  @on-change="changePage"
                @on-page-size-change="changeSize" />
            </Footer>
          </div>
        </Col>
    </Row>
  <CompanyEdit ref="companyEdit"></CompanyEdit>
 
</div>
</template>

<script>

  import CompanyEdit from '@/pages/platform/company/CompanyEdit';
  import  downloadTemplate   from "@/utils/downloadFile";
  import {getCookie} from '@/utils/cookieUtils'

  export default {
    components: {
        CompanyEdit
    },
    methods: {
    
      selectRow(selection) {
        this.selectRows = selection;
      },
    
          //导出
      openExport(){
            let url = `/api/search_url_export`
                      this.req({
                         url: url,
                          method: 'post',
				                	responseType: "arraybuffer",
                          data: {
                              keyword:this.queryForm.keyword,
                          }
                      }).then(response => {
                          downloadTemplate.fileDownload(response.data, "file.xlsx");
                     }).catch(error => {
                          this.$Message.error('服务器错误:' + error)
                     })
      },
    
    
 
    
      loadPage() {
         this.loading = false
        let url   = `api/search_url_data`
        this.req({
          url: url,
          method: 'post',
          data:{
            p: this.current,
            pageSize: this.pageSize,
            keyword:this.queryForm.keyword,
            type: 2
          }
        }).then(resp => {
          this.buildPageData(resp.data.page)
          this.loading = false
        }).catch(error => {
          this.$Message.error('服务器错误2:' + error);
        })
      },
      changePage(curPage) {
        this.loading = true
        this.current = curPage
        this.loadPage()
      },

      changeSize(pageSize) {
        this.pageSize = pageSize
        this.loading = true
        this.loadPage()
      },
      buildPageData(dataObj) {
        this.listData = dataObj.list;
        this.pageSize = dataObj.size;
        this.rowCount = dataObj.rowCount;
        this.currentPage = dataObj.p;
      },
      resetQueryForm() {
        this.$refs["queryFormRef"].fields.forEach(function (e) {
           e.resetField()
        })
      },
      queryBtn(){
                this.current = 1
                this.loadPage()
      },
   
     
     
    },
    mounted: function () {
       this.loadPage();
       
    },
    data() {
      return {
        listData: [],
        pageSize: 10,
        current: 1,
        rowCount: 0,
        loading: true,
        deleteId: '',
        showcity: true,
        showcountry: true,
        uploadUrl:'',  
        showUploadList: false,   
       headers: {
            token: getCookie('wcToken') 
        },  
        columns4: [{
							type: 'index',
							title: '序号',
							width: 60,
							align: 'center',
						},
					   {
							title: '分类',
							width:100,
							key: 'category' ,
							align: 'center',
						}	,
						{
							title: '内容',
							key: 'title' ,
							align: 'center',
							render:(h,params)=>{
								let text=''
								
								text='<div>'+
								'<div style="float:left;text-align:left;"><div>'+
								'<span  style="font-size:12px;font-weight:600"><a target="+blank" href='+params.row.url+'>'+params.row.title+'</a></span> </div>';
								if(params.row.content!=''&&params.row.content!=undefined){
									text+='<div>'+ params.row.content+'</div> '
								}
								if(params.row.info!=''&&params.row.info!=undefined){
									text+='<div>'+ params.row.info+'</div>'
								}
								if(params.row.img.length>0){
									text+=' <div class="imgWrap">'
									for(let i=0;i<params.row.img.length&&i<5;i++){
										text+='<div class="imgContent" > '+
										     '<img referrer="no-referrer|origin|unsafe-url" class="" src="'+params.row.img[i]+'" style="height: 100px;"> </div>'
									}									
									text+=' </div>'
								}						
								
								text+='<div >'
								if(params.row.type!=''&&params.row.type!=undefined){
									text+='  '+
									'<i class="iconfont" style="font-size: 16px;">&#xe738;</i><span style="color: #2A5585;"> '+params.row.type+' &nbsp;&nbsp;</span>'   
								}
								if(params.row.minPrice!=''&&params.row.minPrice!=undefined){
									text+='  '+
									'<i class="iconfont" style="font-size: 16px;">&#xe695;</i><span style="color: #2A5585;"> '+params.row.minPrice+'元 &nbsp;&nbsp;</span>'   
								}
								if(params.row.supplierInfo!=''&&params.row.supplierInfo!=undefined){
									text+='  '+
									'<i class="iconfont" style="font-size: 16px;">&#xe62f;</i><span style="color: #2A5585;cursor: pointer;" onclick=toCompanyInfo("'+params.row.supplierInfo+'","'+params.index+'")> '+params.row.supplierInfo+' &nbsp;&nbsp;</span>'   
								}
								
								if(params.row.releaseTime!=''&&params.row.releaseTime!=undefined){
									text+=''+
									'<i class="iconfont" style="font-size: 16px;">&#xe74f;</i><span style="color:#2A5585"> '+params.row.releaseTime+'</span>'   
								}
								if(params.row.inProvince==0){
									text+=''+
									'<i class="iconfont" style="font-size: 16px;">&#xe62c;</i><span style="color:#2A5585"> 省外</span>'   
								}else{
									text+=''+
									'<i class="iconfont" style="font-size: 16px;">&#xe62c;</i><span style="color:#2A5585">陕西省</span>'   
								}
								if(params.row.venue!=''&&params.row.venue!=undefined){
									text+=''+
									'<i class="iconfont" style="font-size: 16px;">&#xe73a;</i><span style="color:#2A5585"> '+params.row.venue+'</span>'   
								}
								

								text+='</div></div></div>'
								return h("div",{domProps:{
									innerHTML:`<div href=`+params.row.url+` target='_blank'>`+text+`</div>`
								}})
							}
						}, {
							title: '来源',
							width:100,
							key: 'source' ,
							align: 'center',
						},{
							title: '时间',
							width:100,
							key: 'spiderTime' ,
							align: 'center',
						},{
							title: '是否有资质',
							width:100,
							key: 'is_business_unit' ,
							align: 'center',
               render:(h,params)=>{
								let text='是'
                if(params.row.is_business_unit!=1){
                  text='否'
                }
                 
                  return h('div',text)
                }
						}
        ],
       //查询表单的初始值
          queryForm: {
              keyword: '',
          }
      }
    },

  }
</script>

<style scoped>
  .ivu-layout-header {
    background: #f5f7f9;
  }

 

  .queryForm {
    padding: 10px;
  }
  .queryBtn {
    padding-bottom: 5px;
    padding-left: 700px;
    border-bottom: rgb(160, 146, 146) solid 1px;
  }
  .optBtn {
    margin: 10px;
  }
  .ivu-form-item {
    margin-bottom: 0px;
  }
  .a {
    color: #fff;
  }
   .myTitle{
      font-size: 20px;
      font-weight: 700;
  }
    .ivu-upload{
    display: inline-block;
  }
</style>


// WEBPACK FOOTER //
// src/pages/platform/url/urlList.vue